/**
 * src/lib/utils/push.ts
 * Web Push helpers. The only non-trivial piece is converting the VAPID
 * public key — delivered as a URL-safe base64 string by
 * GET /api/v1/notifications/vapid-public-key — into the Uint8Array shape
 * PushManager.subscribe()'s applicationServerKey requires.
 */

export function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

export function isPushSupported(): boolean {
  return typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window;
}
